<template>
    <div class="sidebar col p-0 sidebar-size" :class="open ? 'open' : ''">
        <div class="offcanvas-md offcanvas-end" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
            <div class="offcanvas-body d-md-flex flex-column p-0 pt-lg-0">
                <div class="sidebar-header">
                    <img
                        v-if="open"
                        src="~@/assets/img/prattu-logo-t.svg"
                        alt="Prattu"
                        class="sidebar-logo-full"
                    />
                    <img
                        v-else
                        src="~@/assets/img/prattu-symbol-t.svg"
                        alt="Prattu"
                        class="sidebar-logo-symbol"
                    />
                </div>

                <div class="platform-section">
                    <div v-if="!open" class="platform-collapsed">
                        <button
                            type="button"
                            class="platform-pill"
                            :class="[
                                isCrmActive ? 'platform-pill-active' : 'platform-pill-inactive',
                                isCrmBlocked ? 'platform-pill-locked' : '',
                            ]"
                            :disabled="isCrmBlocked"
                            :title="isCrmBlocked ? crmLockedTitle : ''"
                            @click="onPlatformClick(PLATFORMS.CRM)"
                        >
                            <span v-if="isCrmBlocked" class="platform-lock-icon platform-lock-icon-sm icon-padlock"></span>
                            CRM
                        </button>
                        <button
                            type="button"
                            class="platform-pill"
                            :class="isMarketplaceActive ? 'platform-pill-active' : 'platform-pill-inactive'"
                            @click="onPlatformClick(PLATFORMS.MARKETPLACE)"
                        >
                            MP
                        </button>
                    </div>
                    <div v-else class="platform-expanded">
                        <p class="platform-label">PLATAFORMA</p>
                        <div class="platform-toggle">
                            <button
                                type="button"
                                class="platform-tab"
                                :class="[
                                    isCrmActive ? 'platform-tab-active' : 'platform-tab-inactive',
                                    isCrmBlocked ? 'platform-tab-locked' : '',
                                ]"
                                :disabled="isCrmBlocked"
                                :title="isCrmBlocked ? crmLockedTitle : ''"
                                @click="onPlatformClick(PLATFORMS.CRM)"
                            >
                                <span v-if="isCrmBlocked" class="platform-lock-icon icon-padlock"></span>
                                CRM
                            </button>
                            <button
                                type="button"
                                class="platform-tab"
                                :class="isMarketplaceActive ? 'platform-tab-active' : 'platform-tab-inactive'"
                                @click="onPlatformClick(PLATFORMS.MARKETPLACE)"
                            >
                                Marketplace
                            </button>
                        </div>
                    </div>
                </div>

                <div
                    class="sublinks-floating"
                    :style="{ top: positionSublink + 'px' }"
                    v-show="visibleSublink && !open"
                    @click.stop
                >
                    <template v-for="(sublink, i) in selectedSublinks" :key="i">
                        <router-link
                            v-if="canNavigateSublink(i)"
                            class="nav-sublink"
                            :class="{ 'nav-sublink-active': activePage === i }"
                            :to="sublink.route"
                            @click="closeSublinkPopover"
                        >
                            <span class="sidbar-icon sublink-popover-icon" :class="i === 'orders' ? 'icon-clipboard' : sublink.icon"></span>
                            <span class="sublink-name">{{ sublink.name }}</span>
                        </router-link>
                        <span
                            v-else-if="isSublinkVisible(i)"
                            class="nav-sublink nav-sublink-locked"
                            :class="{ 'nav-sublink-active': activePage === i }"
                        >
                            <span class="sidbar-icon sublink-popover-icon" :class="i === 'orders' ? 'icon-clipboard' : sublink.icon"></span>
                            <span class="sublink-name">{{ sublink.name }}</span>
                        </span>
                    </template>
                </div>
                <div class="menu-content" @scroll="visibleSublink = false">
                    <p class="message" v-if="typeof sidebarData?.message === 'string'">{{ sidebarData?.message }}</p>
                    <ul class="nav nav-top flex-column" :class="typeof sidebarData?.message === 'string' ? '' : ''">
                        <li
                            v-for="(link, index) in links"
                            :key="index"
                            class="nav-item"
                            :class="typeof link.sublinks === 'object' ? 'with-sublink' : ''"
                            v-show="typeof sidebarData?.links !== 'object' || typeof sidebarData?.links[index] === 'object'"
                        >
                            <template v-if="typeof link.sublinks === 'object'">
                                <div ref="clickableElement">
                                    <a
                                        href="#"
                                        class="nav-link menu-parent-link d-flex align-items-center"
                                        :class="[
                                            parentMenu === index ? 'menu-parent' : '',
                                            open && isMenuExpanded(index) ? 'is-expanded' : 'collapsed',
                                        ]"
                                        v-tippy="collapsedTooltip(link.name)"
                                        @click.prevent.stop="onParentMenuClick(index, link.sublinks, $event)"
                                    >
                                        <span class="sidbar-icon" :class="link.icon"></span>
                                        <span class="name">{{ link.name }}</span>
                                        <svg
                                            v-if="open"
                                            class="menu-chevron"
                                            :class="{ 'is-expanded': isMenuExpanded(index) }"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            aria-hidden="true"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </a>
                                    <div
                                        v-show="isMenuExpanded(index)"
                                        class="sublinks-list"
                                    >
                                        <div class="sublink" v-for="(sublink, i) in link.sublinks" :key="i">
                                            <span v-if="typeof sidebarData?.links !== 'object' || typeof sidebarData?.links[i] === 'object'" :class="'menu-' + i">
                                                <router-link
                                                    class="nav-link d-flex align-items-center sublink"
                                                    :to="sublink.route"
                                                    :class="[activePage === i ? 'icon-active' : '']"
                                                    v-if="typeof sidebarData?.links !== 'object' || sidebarData?.links[i]?.complete"
                                                >
                                                    <span class="sidbar-icon info-icon" :class="checkAddIcon(i)"></span>
                                                    <span class="sidbar-icon sublink-menu-icon" :class="sublink.icon"></span>
                                                    <span class="name">{{ sublink.name }}</span>
                                                </router-link>
                                                <span
                                                    class="nav-link d-flex align-items-center sublink"
                                                    :class="[activePage === i ? 'icon-active' : '']"
                                                    v-else
                                                >
                                                    <span class="sidbar-icon info-icon" :class="checkAddIcon(i)"></span>
                                                    <span class="sidbar-icon sublink-menu-icon" :class="sublink.icon"></span>
                                                    <span class="name">{{ sublink.name }}</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <router-link
                                v-else
                                class="nav-link d-flex align-items-center"
                                :to="link.route"
                                :class="[activePage === index ? 'icon-active' : '']"
                                v-tippy="collapsedTooltip(link.name)"
                            >
                                <span class="sidbar-icon info-icon" :class="checkAddIcon(index)"></span>
                                <span class="sidbar-icon" :class="link.icon"></span>
                                <span class="name">{{ link.name }}</span>
                            </router-link>
                        </li>
                    </ul>
                    <!-- <ul class="nav nav-bottom flex-column">
                        <li class="nav-item item-help" v-if="completeConfig">
                            <router-link to="/ajuda" class="nav-link d-flex align-items-center" aria-current="page" v-tippy="collapsedTooltip('Ajuda')">
                                <span class="sidbar-icon icon-helper"></span>
                                <span class="name">Ajuda</span>
                            </router-link>
                        </li>
                        <li class="nav-item item-exit">
                            <router-link to="#" @click.prevent="logout()" class="nav-link d-flex align-items-center" aria-current="page" v-tippy="collapsedTooltip('Sair')">
                                <span class="sidbar-icon icon-power"></span>
                                <span class="name">Sair</span>
                            </router-link>
                        </li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue';
import { mapState, useStore } from 'vuex';
import axios from 'axios';
import { emitter } from '@/store';
import { useToast } from '@/composables/useToast';

const PLATFORMS = {
    MARKETPLACE: 'marketplace',
    CRM: 'crm',
};

export default {
    name: "Sidebar",
    data() {
        return {
            PLATFORMS,
            open: false,
            lastLink: "",
            selectedSublinks: [],
            positionSublink: 0,
            visibleSublink: false,
            completeConfig: false,
            parentMenu: '',
            expandedMenus: {},
            platformConfig: {
                activePlatform: PLATFORMS.MARKETPLACE,
                access: {
                    [PLATFORMS.MARKETPLACE]: {
                        available: true,
                        redirectUrl: null,
                    },
                    [PLATFORMS.CRM]: {
                        available: true,
                        lockedReason: '',
                        redirectUrl: null, // ex: process.env.VUE_APP_CRM_URL
                    },
                },
            },
            links: {
                monitor: { 
                    icon: "icon-monitor", 
                    name: "Monitor Performance", 
                    sublinks: {
                        overview: { icon: "icon-grid", name: "Visão geral", route: "/visao" },
                        sales: { icon: "icon-performance", name: "Vendas", route: "/vendas" },
                        operacional: { icon: "icon-efficiency", name: "Eficiência operacional", route: "/operacional" },
                        crm: { icon: "icon-summarize", name: "CRM", route: "/crm" },
                        customers: { icon: "icon-customers", name: "Análise de clientes", route: "/clientes" },
                        performance: { icon: "icon-insights", name: "Performance do cardápio", route: "/performance" },
                        payments: { icon: "icon-payment", name: "Pagamentos", route: "/pagamentos" },
                    }
                },
                store: {
                    icon: "icon-settings", 
                    name: "Configuração da loja", 
                    sublinks: {
                        hours: { icon: "icon-clock", name: "Horário funcionamento", route: "/horario" },
                        preparation: { icon: "icon-pot", name: "Tempo de preparação", route: "/preparo" },
                        profile: { icon: "icon-account", name: "Perfil", route: "/perfil" },
                        menu: { icon: "icon-summarize", name: "Cardápio", route: "/cardapio" },
                        config: { icon: "icon-slider", name: "Configurações da conta", route: "/configuracoes" },
                        promotions: { icon: "icon-promotion", name: "Promoções", route: "/promocoes" },
                    }
                },
                management: {
                    icon: "icon-clipboard", 
                    name: "Gestor de pedidos", 
                    sublinks: {
                        orders: { icon: "icon-assignment", name: "Pedidos", route: "/pedidos" },
                        printing: { icon: "icon-printer", name: "Impressão", route: "/impressao" },
                        history: { icon: "icon-summarize", name: "Histórico de pedidos", route: "/historico" },
                        support: { icon: "icon-support", name: "Chamados/suporte", route: "/chamados" },
                    }
                }
            }
        } 
    },
    computed: {
        ...mapState(['sidebarData', 'restaurantId', 'platformAccess']),
        isMarketplaceActive() {
            // Neste front (Marketplace) o switcher sempre exibe Marketplace como ativo
            return true;
        },
        isCrmActive() {
            return false;
        },
        isCrmAvailable() {
            return this.isPlatformAvailable(PLATFORMS.CRM);
        },
        isCrmBlocked() {
            return !this.isCrmAvailable;
        },
        crmAccess() {
            return this.getPlatformAccess(PLATFORMS.CRM);
        },
        crmLockedTitle() {
            return this.crmAccess?.lockedReason ?? '';
        },
    },
    setup(props, { emit }) {
        let intervalIdSidebar;
        const store = useStore();
        const { showError } = useToast();
        const lastPendingOrderIdsSidebar = ref([]);
        const lastPreparationOrderIdsSidebar = ref([]);
        const pendingOrdersSidebar = ref([]);
        const notificationSound = ref(null);
        const audioReady = ref(false);
        let isFirstRun = true;
        let soundInterval = null;

        const prepareNotificationSound = () => {
            notificationSound.value = new Audio('/notification.mp3');
            notificationSound.value.load();
            audioReady.value = true;
        };

        const playNotificationSound = () => {
            if (audioReady.value && notificationSound.value) {
                notificationSound.value.play().catch((err) => {
                    console.warn('Erro ao tocar som:', err);
                });
            }
        };

        const arraysAreEqual = (a, b) => {
            return a.length === b.length && a.every((val, index) => val === b[index]);
        };
        
        const fetchAllOrders = async () => {
            if (!store.state.token || !store.state.restaurantId) {
                return;
            }

            try {
                const dataRestaurant = await axios.get(`${process.env.VUE_APP_LARAVEL_API_URL}/restaurants/${store.state.restaurantId}`, {
                    headers: { Authorization: `Bearer ${store.state.token}` }
                });
                const auto_order = dataRestaurant.data.auto_order;
                
                const response = await axios.get(`${process.env.VUE_APP_LARAVEL_API_URL}/orders/status/1`, {
                    headers: {
                        Authorization: `Bearer ${store.state.token}`,
                    }
                });
                
                const responsePreparation = await axios.get(`${process.env.VUE_APP_LARAVEL_API_URL}/orders/status/2`, {
                    headers: {
                        Authorization: `Bearer ${store.state.token}`,
                    }
                });

                const newOrderList = response.data;
                const newOrderIds = newOrderList.map(order => order.id);
                
                const newPreparationList = responsePreparation.data;
                const newPreparationIds = newPreparationList.map(order => order.id);

                if (newOrderList.length === 0 || auto_order) {
                    if (soundInterval) {
                        clearInterval(soundInterval);
                        soundInterval = null;
                    }
                }

                // Só compara se não for a primeira execução
                if (!isFirstRun) {
                    const newIds = newOrderIds.filter(id => !lastPendingOrderIdsSidebar.value.includes(id));
                    if (newIds.length > 0) {
                        if (auto_order) {
                            playNotificationSound();
                        } else {
                            playNotificationSound();
                            if (!soundInterval) {
                                soundInterval = setInterval(() => {
                                    playNotificationSound();
                                }, 5000);
                            }
                        }
                    }

                    const newPrepIds = newPreparationIds.filter(id => !lastPreparationOrderIdsSidebar.value.includes(id));
                    if (newPrepIds.length > 0 && auto_order) {
                        playNotificationSound();
                    }
                } else {
                    isFirstRun = false;
                    if (!auto_order && newOrderList.length > 0) {
                        if (!soundInterval) {
                            soundInterval = setInterval(() => {
                                playNotificationSound();
                            }, 5000);
                        }
                    }
                }

                lastPendingOrderIdsSidebar.value = [...newOrderIds];
                lastPreparationOrderIdsSidebar.value = [...newPreparationIds];
                pendingOrdersSidebar.value = newOrderList;
            } catch (error) {
                console.error("Erro ao buscar pedidos:", error);
            }
        };

        onMounted(() => {
            // Ativa o som após o primeiro clique do usuário
            window.addEventListener('click', () => {
                if (!audioReady.value) prepareNotificationSound();
            }, { once: true });

            fetchAllOrders();
            intervalIdSidebar = setInterval(fetchAllOrders, 60000);
        });

        onUnmounted(() => {
            if (intervalIdSidebar) clearInterval(intervalIdSidebar);
            if (soundInterval) clearInterval(soundInterval);
        });

        return {
            pendingOrdersSidebar,
        };

    },
    props: {
        activePage: String
    },
    methods: {
        openClose() {
            this.open = !this.open;
            this.visibleSublink = false;
            this.hideSidebarTooltips();
            this.updateLayout();
        },
        hideSidebarTooltips() {
            this.$el?.querySelectorAll('.nav-link, .menu-parent-link').forEach((el) => {
                el._tippy?.hide();
            });
        },
        updateLayout() {
            const sidebarWidth = this.open ? '260px' : '48px';
            document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
            document.documentElement.classList.toggle('sidebar-expanded', this.open);

            const mainElement = document.querySelector('main');
            if (!mainElement) return;
            const firstChild = mainElement.querySelector('div');
            if (!firstChild) return;

            if (this.open) {
                firstChild.style.marginLeft = '280px';
                firstChild.classList.add('sidebar-open');
            } else {
                firstChild.style.marginLeft = '66px';
                firstChild.classList.remove('sidebar-open');
            }
        },
        checkAddIcon(index) {
            if (typeof this.sidebarData?.links === "object") {
                if (typeof this.sidebarData?.links[index] === "object") {
                    if (typeof this.sidebarData?.links[index].complete === "boolean") {
                        if (this.sidebarData?.links[index].complete) {
                            return 'check-on';
                        } else {
                            return 'icon-alert';
                        }
                    } else {
                        return 'd-none';
                    }
                } else {
                    return 'd-none';
                }
            } else {
                return 'd-none';
            }
        },
        isSublinkVisible(index) {
            return typeof this.sidebarData?.links !== 'object' || typeof this.sidebarData?.links[index] === 'object';
        },
        canNavigateSublink(index) {
            if (typeof this.sidebarData?.links !== 'object') {
                return true;
            }

            return this.sidebarData?.links[index]?.complete === true;
        },
        selectSublink(link, sublinks, event) {
            this.visibleSublink = link === this.lastLink ? !this.visibleSublink : true;
            this.lastLink = link;
            if (!this.visibleSublink) return;

            const navItem = event.currentTarget?.closest?.('.nav-item') ?? event.currentTarget;
            const rect = navItem.getBoundingClientRect();
            this.positionSublink = rect.top;
            this.selectedSublinks = sublinks;
        },
        onParentMenuClick(index, sublinks, event) {
            if (!this.open) {
                this.selectSublink(index, sublinks, event);
                return;
            }
            this.toggleMenu(index);
        },
        closeSublinkPopover() {
            this.visibleSublink = false;
        },
        handleDocumentClick(event) {
            if (!this.visibleSublink || this.open) return;
            if (this.$el?.contains(event.target)) return;
            this.visibleSublink = false;
        },
        collapsedTooltip(label) {
            if (this.open) {
                return {
                    content: '',
                    trigger: 'manual',
                };
            }
            return {
                content: label,
                theme: 'sidebar-title',
                placement: 'right',
                offset: [0, 8],
                arrow: false,
                delay: [200, 0],
                trigger: 'mouseenter focus',
            };
        },
        findParentMenu(menu) {
            for (const parentKey in this.links) {
                const link = this.links[parentKey];
                if (link.sublinks) {
                    for (const key in link.sublinks) {
                        if (key === menu) {
                            return parentKey;
                        }
                    }
                }
            }
            return null;
        },
        isMenuExpanded(index) {
            return !!this.expandedMenus[index];
        },
        toggleMenu(index) {
            if (!this.open) return;
            this.expandedMenus[index] = !this.expandedMenus[index];
        },
        /**
         * Retorna o objeto de acesso de uma plataforma.
         * Integração back: popular via applyPlatformAccessFromApi().
         */
        getPlatformAccess(platform) {
            return this.platformConfig.access[platform] ?? null;
        },
        isPlatformAvailable(platform) {
            return this.getPlatformAccess(platform)?.available === true;
        },
        isPlatformBlocked(platform) {
            return !this.isPlatformAvailable(platform);
        },
        /**
         * Normaliza e aplica resposta do back.
         * Formato esperado:
         * {
         *   active_platform: 'marketplace' | 'crm',
         *   platforms: {
         *     marketplace: { available: true, redirect_url: null },
         *     crm: { available: false, locked_reason: '...', redirect_url: 'https://...' }
         *   }
         * }
         */
        applyPlatformAccessFromApi(data = {}) {
            const platforms = data.platforms ?? data.access;
            if (platforms) {
                Object.keys(platforms).forEach((platform) => {
                    const source = platforms[platform];
                    if (!this.platformConfig.access[platform]) return;

                    this.platformConfig.access[platform] = {
                        available: source.available ?? source.enabled ?? false,
                        lockedReason: source.locked_reason ?? source.lockedReason ?? '',
                        redirectUrl: source.redirect_url ?? source.redirectUrl ?? null,
                    };
                });
            }

            // Neste app o switcher permanece sempre em Marketplace
            this.platformConfig.activePlatform = PLATFORMS.MARKETPLACE;

        },
        /**
         * Carrega permissões de plataforma já retornadas pela API/bootstrap.
         */
        async loadPlatformAccess() {
            const access = this.platformAccess || {};
            this.applyPlatformAccessFromApi({
                active_platform: PLATFORMS.MARKETPLACE,
                platforms: {
                    [PLATFORMS.MARKETPLACE]: {
                        available: access.marketplace?.available ?? access.hasMarketplace ?? access.has_marketplace ?? true,
                        redirect_url: null,
                    },
                    [PLATFORMS.CRM]: {
                        available: access.crm?.available ?? access.hasCRM ?? access.has_crm ?? false,
                        locked_reason: access.crm?.lockedReason ?? access.crm?.locked_reason ?? '',
                        redirect_url: access.crm?.redirectUrl ?? access.crm?.redirect_url ?? null,
                    },
                },
            });
        },
        async onPlatformClick(platform) {
            if (this.isPlatformBlocked(platform)) {
                return;
            }

            if (platform === PLATFORMS.CRM) {
                await this.navigateToCrm();
                return;
            }

        },
        /**
         * Navega para o CRM sem alterar o estado ativo do switcher.
         * O Marketplace permanece sempre selecionado neste app.
         */
        async navigateToCrm() {
            const access = this.getPlatformAccess(PLATFORMS.CRM);

            try {
                if (access?.redirectUrl) {
                    window.location.href = access.redirectUrl;
                    return;
                }

                const response = await axios.post(
                    `${process.env.VUE_APP_LARAVEL_API_URL}/crm/sso/start`,
                    { returnTo: '/' },
                    { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
                );

                if (!response.data?.redirectUrl) {
                    throw new Error('URL de acesso ao CRM não retornada pela API.');
                }

                window.location.href = response.data.redirectUrl;
            } catch (error) {
                console.error('[Platform] falha ao navegar para CRM', error);
                alert(error?.response?.data?.message || error?.message || 'Não foi possível abrir o CRM.');
            }
        },
        /**
         * @deprecated Usar onPlatformClick / navigateToCrm.
         * Mantido para referência de integração futura.
         */
        async switchPlatform(platform) {
            if (platform === PLATFORMS.CRM) {
                await this.navigateToCrm();
                return;
            }

            this.platformConfig.activePlatform = PLATFORMS.MARKETPLACE;
        },
        logout() {
            this.$store.dispatch('resetStore');
            this.$router.push('/login');
        }
    },
    created() {
        if (this.$store.state.completeConfig && !this.$store.state.available && this.$route.name !== 'config') {
            this.$router.push('/configuracoes');
        }
        
        if (!this.$store.state.token) {
            this.$router.push('/login');
        }
    },
    mounted() {
        this.completeConfig = (this.$store.state.completeConfig && this.$store.state.available) ? true : false;
        if  (!this.$store.state.completeConfig || !this.$store.state.available) {
            this.open = true;
        } else {
            this.open = this.sidebarData?.open;
        }
        this.updateLayout();
        this.parentMenu = this.findParentMenu(this.activePage);
        if (this.parentMenu) {
            this.expandedMenus = { [this.parentMenu]: true };
        }

        this.loadPlatformAccess();
        emitter.on('toggleSidebar', this.openClose);
        document.addEventListener('click', this.handleDocumentClick);
    },
    beforeUnmount() {
        emitter.off('toggleSidebar', this.openClose);
        document.removeEventListener('click', this.handleDocumentClick);
    },
};
</script>


<style lang="scss" scoped>
    $sidebar-border: #323238;
    $sidebar-accent: #33333D;
    $sidebar-foreground: rgba(255, 255, 255, 0.8);
    $sidebar-muted: rgba(255, 255, 255, 0.55);
    $sidebar-text: rgba(255, 255, 255, 0.8);
    $sidebar-item-radius: 10px;

    .offcanvas-body {
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .sidebar-header {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 70px;
        border-bottom: 1px solid $sidebar-border;
        flex-shrink: 0;
    }

    .sidebar:not(.open) .sidebar-header {
        padding: 0 6px;
    }

    .sidebar.open .sidebar-header {
        padding: 0 16px;
    }

    .sidebar-logo-full {
        height: 32px;
        width: auto;
        object-fit: contain;
    }

    .sidebar-logo-symbol {
        width: 36px;
        height: 36px;
        object-fit: contain;
    }

    .platform-section {
        border-bottom: 1px solid $sidebar-border;
        flex-shrink: 0;
    }

    .platform-collapsed {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 6px;
        padding: 8px 6px;
    }

    .platform-collapsed .platform-pill {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        padding: 4px 0 !important;
        border: none !important;
        border-radius: 10px !important;
        font-size: 10px !important;
        font-weight: 700;
        line-height: 1;
        text-align: center;
    }

    .platform-collapsed .platform-pill-inactive {
        font-weight: 600;
        font-size: 10px !important;
        color: rgba(255, 255, 255, 0.35);
    }

    .platform-collapsed .platform-pill-locked {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 2px;
        cursor: not-allowed !important;
        color: rgba(255, 255, 255, 0.35) !important;
    }

    .platform-pill {
        width: 100%;
        padding: 4px 0;
        border: none;
        border-radius: 10px;
        font-size: 10px;
        font-weight: 700;
        text-align: center;
        line-height: 1;
        cursor: pointer;
        transition: background-color 0.15s, color 0.15s;
    }

    .platform-pill-active {
        background-color: $green-primary;
        color: $white-primary;
    }

    .platform-pill-inactive {
        background: transparent;
        color: rgba(255, 255, 255, 0.4);
        font-weight: 600;

        &:hover:not(:disabled) {
            color: rgba(255, 255, 255, 0.7);
            background-color: rgba(255, 255, 255, 0.06);
        }
    }

    .platform-expanded {
        padding: 12px;
    }

    .platform-label {
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: $sidebar-muted;
        margin: 0 0 8px;
    }

    .platform-toggle {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px;
        border-radius: 12px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .platform-expanded .platform-toggle .platform-tab {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        box-sizing: border-box !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        padding: 8px 8px !important;
        margin: 0 !important;
        border: none !important;
        border-radius: 10px !important;
        font-size: 12px !important;
        font-weight: 600;
        line-height: 1 !important;
        cursor: pointer;
        transition: background-color 0.15s, color 0.15s;
    }

    .platform-tab-active {
        background-color: $green-primary;
        color: $white-primary;
    }

    .platform-tab-inactive {
        background: transparent;
        color: rgba(255, 255, 255, 0.4);
        font-weight: 500;

        &:hover:not(:disabled) {
            color: rgba(255, 255, 255, 0.75);
            background-color: rgba(255, 255, 255, 0.06);
        }
    }

    .platform-tab-locked {
        cursor: not-allowed !important;
        color: rgba(255, 255, 255, 0.4) !important;

        &:disabled {
            opacity: 1;
        }
    }

    .platform-lock-icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-size: 12px 12px;
        opacity: 0.5;
        filter: brightness(0) invert(1);
        flex-shrink: 0;
    }

    .platform-lock-icon-sm {
        width: 8px;
        height: 8px;
        background-size: 8px 8px;
    }

    .sidebar-size {
        width: 48px;
        height: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 1100;
        border: none !important;
        border-right: 1px solid $sidebar-border !important;
        background-color: $black-primary;
    }

    .message,
    .nav-item .info-icon,
    .nav-item .name,
    .menu-chevron {
        display: none;
    }

    .sidbar-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        min-width: 16px;
        background-size: 16px 16px;
        background-repeat: no-repeat;
        background-position: center center;
        flex-shrink: 0;
        opacity: 0.8;
    }

    .nav {
        --bs-nav-link-padding-y: 0 !important;
        width: 100%;
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .nav-top {
        padding: 8px;
    }

    .nav-item {
        width: 100%;
        margin-bottom: 0;
    }

    .nav-item .nav-link {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        min-height: 32px;
        height: 32px;
        padding: 8px;
        border-radius: $sidebar-item-radius;
        color: $sidebar-foreground;
        font-size: 14px;
        line-height: 1.25;
        text-decoration: none;
        transition: background-color 0.15s ease, color 0.15s ease;
        position: relative;

        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
            color: $white-primary;

            .sidbar-icon {
                opacity: 1;
            }
        }
    }

    .nav-bottom {
        margin-top: auto;
        width: 100%;
        border-top: 1px solid $sidebar-border;
        padding: 8px;
    }

    .sublinks-floating {
        position: fixed;
        left: calc(var(--sidebar-width, 48px) + 8px);
        background-color: #fff;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        min-width: 176px;
        padding: 4px;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        z-index: 1200;

        .nav-sublink {
            display: flex;
            align-items: center;
            gap: 8px;
            width: 100%;
            padding: 8px 12px;
            text-decoration: none;
            color: #202025;
            border-radius: $sidebar-item-radius;
            font-size: 14px;
            line-height: 1.25;
            transition: background-color 0.15s ease, color 0.15s ease;

            &:hover {
                background-color: #ebebeb;
                color: #202025;

                .sublink-popover-icon {
                    filter: brightness(0) saturate(100%);
                }
            }
        }

        .nav-sublink-locked {
            cursor: not-allowed;
            color: #8a8a8a;

            &:hover {
                background-color: transparent;
                color: #8a8a8a;
            }
        }

        .nav-sublink-active {
            background-color: rgba(46, 137, 7, 0.1);
            color: #2e8907;
            font-weight: 500;

            .sublink-popover-icon {
                filter: brightness(0) saturate(100%) invert(32%) sepia(98%) saturate(749%) hue-rotate(73deg) brightness(92%) contrast(89%);
            }
        }

        .sublink-popover-icon {
            display: inline-block !important;
            width: 16px;
            height: 16px;
            min-width: 16px;
            background-size: 15px 15px;
            opacity: 1 !important;
            filter: brightness(0) saturate(100%);
        }

        .sublink-name {
            font-size: 14px;
        }
    }

    .sidebar:not(.open) .sublink,
    .sidebar:not(.open) .sublinks-list {
        display: none !important;
    }

    .sidebar.open {
        width: 260px;

        .message,
        .nav-item .info-icon,
        .nav-item .name,
        .menu-chevron {
            display: block;
        }

        .nav-item .name {
            flex: 1;
            margin-left: 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 1.25;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .message {
            padding: 8px 8px 4px;
            font-size: 12px;
            color: $sidebar-muted;
        }

        .menu-chevron {
            display: block;
            width: 14px;
            height: 14px;
            min-width: 14px;
            margin-left: auto;
            flex-shrink: 0;
            opacity: 0.7;
            color: $sidebar-foreground;
            transform: rotate(-90deg);
            transition: transform 0.2s ease, opacity 0.15s ease, color 0.15s ease;
        }

        .menu-chevron.is-expanded {
            transform: rotate(0deg);
        }

        .icon-active,
        .menu-parent {
            background-color: $sidebar-accent !important;

            .name {
                color: $light-green !important;
                font-weight: 500;
            }

            .sidbar-icon:not(.info-icon) {
                opacity: 1 !important;
                filter: brightness(0) saturate(100%) invert(72%) sepia(61%) saturate(1828%) hue-rotate(65deg) brightness(103%) contrast(95%);
            }

            .menu-chevron {
                opacity: 1;
                color: $light-green;
            }
        }

        .menu-parent-link:hover .menu-chevron {
            color: $white-primary;
            opacity: 1;
        }

        .menu-parent-link.menu-parent .menu-chevron {
            color: $light-green;
            opacity: 1;
        }

        .icon-active .info-icon {
            display: none !important;
        }

        .sublinks-list {
            display: flex;
            flex-direction: column;
            gap: 4px;
            padding: 0;
            margin-top: 4px;
        }

        .sublinks-list .sublink .nav-link {
            min-height: 32px;
            height: 32px;
            padding: 8px 8px 8px 36px;
            border-radius: $sidebar-item-radius;
            gap: 8px;
            font-size: 14px;
            line-height: 1.25;

            .name {
                font-size: 14px;
                opacity: 0.8;
                margin-left: 0;
                font-weight: 400;
            }

            .sublink-menu-icon {
                width: 14px;
                height: 14px;
                min-width: 14px;
                background-size: 14px 14px;
                opacity: 0.8;
            }

            &:hover {
                background-color: rgba(255, 255, 255, 0.1);
                color: $white-primary;

                .name {
                    opacity: 1;
                }

                .sublink-menu-icon {
                    opacity: 1;
                }
            }

            &.icon-active {
                background-color: $sidebar-accent !important;

                .name {
                    color: $light-green !important;
                    opacity: 1;
                    font-weight: 500;
                }

                .sublink-menu-icon {
                    opacity: 1;
                    filter: brightness(0) saturate(100%) invert(72%) sepia(61%) saturate(1828%) hue-rotate(65deg) brightness(103%) contrast(95%);
                }

                &:hover {
                    background-color: $sidebar-accent !important;
                    color: $light-green;

                    .name {
                        color: $light-green !important;
                    }
                }
            }
        }

        .nav-top .menu-orders .nav-link {
            .name {
                font-weight: 500;
            }
        }

        .sublinks-floating {
            display: none;
        }
    }

    .menu-content {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    .menu-content::-webkit-scrollbar {
        width: 8px;
    }

    .menu-content::-webkit-scrollbar-track {
        background: transparent;
    }

    .menu-content::-webkit-scrollbar-thumb {
        background-color: $sidebar-border;
        border-radius: 20px;
    }

    .item-help,
    .item-exit {
        padding: 0;
    }

    .sidebar:not(.open) {
        .nav-top,
        .nav-bottom {
            padding: 8px 0;
        }

        .nav-item {
            width: 32px;
            margin: 0 auto;
        }

        .nav-item .nav-link {
            justify-content: center;
            padding: 8px;
            width: 32px;
            height: 32px;
            min-height: 32px;
            margin: 0 auto;
            border-radius: $sidebar-item-radius;
            gap: 0;
        }

        .nav-item .sidbar-icon {
            margin: 0;
            opacity: 0.8;
        }

        .nav-item .nav-link:hover .sidbar-icon {
            opacity: 1;
        }

        .icon-active .nav-link,
        .menu-parent .nav-link {
            background-color: $sidebar-accent;
        }

        .icon-active .sidbar-icon,
        .menu-parent .sidbar-icon {
            opacity: 1 !important;
            filter: brightness(0) saturate(100%) invert(72%) sepia(61%) saturate(1828%) hue-rotate(65deg) brightness(103%) contrast(95%);
        }
    }
</style>